import React from 'react';

const TitleField = ({ text, required }) => (
  <label className='form-field-title'>
    {text} {required && <span className='form-field-title__required'>*</span>}
  </label>
)

export default TitleField;
